import React from 'react';
import {
  FaFileExcel,
  FaFilePdf,
  FaFileWord,
  FaRegImage,
  FaRegFolderOpen
} from 'react-icons/fa';
import { GoFileZip } from 'react-icons/go';

/**
 * Retorna o ícone apropriado baseado na extensão do arquivo
 * @param fileName Nome do arquivo incluindo extensão
 * @returns Componente React do ícone
 */
export const getFileIcon = (fileName: string) => {
  const ext = fileName.split('.').pop()?.toLowerCase();
  
  switch (ext) {
    case 'pdf':
      return React.createElement(FaFilePdf, { className: 'text-red-500' });
    case 'doc':
    case 'docx':
      return React.createElement(FaFileWord, { className: 'text-blue-600' });
    case 'xls':
    case 'xlsx':
      return React.createElement(FaFileExcel, { className: 'text-green-600' });
    case 'png':
    case 'jpg':
    case 'jpeg':
    case 'gif':
      return React.createElement(FaRegImage, { className: 'text-purple-500' });
    case 'zip':
    case 'rar':
      return React.createElement(GoFileZip, { className: 'text-yellow-600' });
    default:
      return React.createElement(FaRegFolderOpen, { className: 'text-gray-500' });
  }
};

/**
 * Retorna o tipo de arquivo baseado na extensão
 * @param fileName Nome do arquivo incluindo extensão
 * @returns Tipo do arquivo
 */
export const getFileType = (fileName: string): string => {
  const ext = fileName.split('.').pop()?.toLowerCase();
  
  switch (ext) {
    case 'pdf':
      return 'PDF';
    case 'doc':
    case 'docx':
      return 'Word';
    case 'xls':
    case 'xlsx':
      return 'Excel';
    case 'png':
    case 'jpg':
    case 'jpeg':
    case 'gif':
      return 'Imagem';
    case 'zip':
    case 'rar':
      return 'Arquivo';
    default:
      return 'Documento';
  }
};

/**
 * Retorna a cor de fundo apropriada para o tipo de arquivo
 * @param fileName Nome do arquivo incluindo extensão
 * @returns Classes CSS para a cor
 */
export const getFileBackgroundColor = (fileName: string): string => {
  const ext = fileName.split('.').pop()?.toLowerCase();
  
  switch (ext) {
    case 'pdf':
      return 'bg-red-50 border-red-200';
    case 'doc':
    case 'docx':
      return 'bg-blue-50 border-blue-200';
    case 'xls':
    case 'xlsx':
      return 'bg-green-50 border-green-200';
    case 'png':
    case 'jpg':
    case 'jpeg':
    case 'gif':
      return 'bg-purple-50 border-purple-200';
    case 'zip':
    case 'rar':
      return 'bg-yellow-50 border-yellow-200';
    default:
      return 'bg-gray-50 border-gray-200';
  }
};